<template>
  <div class="d-flex align-center" style="width: 100%">
    <div class="grey--text text--darken-1">Mark this card as used</div>
    <v-spacer />
    <v-switch dense hide-details inset class="mt-0" :input-value="redemption.is_used" @change="switchChanged"/>
  </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  name: 'RewardEnableBar',

  props: ['redemption'],

  methods: {
    ...mapActions('rewards', ['updateReward']),

    switchChanged(is_used) {
      const { redemption_id } = this.redemption
      this.updateReward({ redemption_id, is_used })
    },
  },
}
</script>